<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-18T14:07:39+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-17T16:31:05+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>
        <b-row>
            <b-col cols="6">
                <div class="card">
                    <span style="" class="badge bg-danger rounded-pill badge-header">{{notification_count}}</span>
                    <div style="width:fit-content; color: #ffffff;" class="card-title card ccb_green p-2">QMS Notices</div>
                    <div style="display: inline-flex;">
                        <div
                        :title="notification.name"
                        class="m-1 p-1 info-tile"
                        style="text-align: center; position: relative;"
                        :class="notification.length == 0 ? 'no-notification' : ''"
                        @click="selectNotification(notification, idx)"
                        v-for="(notification, idx) in notification_data" :key="notification.id">
                            <span style="" class="badge bg-danger rounded-pill notification_count">{{notification.length}}</span>
                            <!--<span style="text-align: center; display: absolute; float: right;">{{notification.length}}</span>-->
                            <div :class="selectedNotificationIndex == idx ? 'selected-notification' : ''" style="width: 100%; text-align: center;">
                                <i style="font-size: 2rem;" class="fas" :class="notification.icon"></i>
                            </div>
                            <div>
                                <p class="text-capitalize text-truncate">{{notification.name}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
            <!--
            <b-col cols="6">
                <b-card style="overflow-x: auto;">
                    <div class="card-title">QMS Notices</div>
                    <span style="display: inline-flex;">
                        <span style="display: inline-flex;">
                            <div
                            :title="notification.name"
                            class="m-1 p-1 info-tile"
                            style="text-align: center;"
                            :class="notification.length == 0 ? 'no-notification' : ''"
                            @click="selectNotification(notification, idx)"
                            v-for="(notification, idx) in notification_data" :key="notification.id">
                                <span style="text-align: center; display: absolute; float: right;">{{notification.length}}</span>
                                <div :class="selectedNotificationIndex == idx ? 'selected-notification' : ''" style="width: 100%; text-align: center;">
                                    <i style="font-size: 2rem;" class="fas" :class="notification.icon"></i>
                                </div>
                                <div>
                                    <p class="text-truncate">{{notification.name}}</p>
                                </div>
                            </div>
                        </span>
                    </span>
                </b-card>
            </b-col>
            -->
            <!--
            <b-col cols="6">
                <b-card>
                    <div class="card-title">Personnel Notices</div>
                </b-card>
            </b-col>
            -->
        </b-row>
        <b-row v-if="showNotifications == false">
            <b-col>
                <b-card :title="returnGroupName" v-if="hasSopGroupSelected">
                    <b-row>
                        <b-col cols="12" class="ps-3 pe-3" style="display: flex;">
                            <b-button variant="outline-primary" class="me-1">
                                <i class="fas fa-search"></i>
                            </b-button>
                            <b-button v-if="search_text !== ''" @click="search_text = ''" variant="warning" class="me-1">
                                <i class="fas fa-times"></i>
                            </b-button>
                            <b-form-input v-model="search_text" style="width: 50rem;"></b-form-input>
                        </b-col>
                    </b-row>

                    <b-overlay :show="show_overlay">
                        <div>
                            <span style="display: inline-flex; flex-wrap: wrap;">
                                <div
                                @contextmenu.prevent="clicker($event, doc.id)"
                                @click="selectedDocument(doc.id)"
                                :title="doc.name"
                                :id="'doc'+doc.id"
                                class="document-tile"
                                v-for="doc in documents" :key="doc.id">
                                    <SopCard :name="doc.name" :code="doc.sop_code" />
                                </div>

                                <div @click="showSopDialog" class="m-1 p-0 document-add-tile" style="text-align: center;">
                                    <i style="font-size: 4rem;" class="pt-2 fas fa-plus"></i>
                                </div>
                            </span>
                        </div>

                        <b-alert :show="documents.length == 0">No Documents </b-alert>
                    </b-overlay>
                </b-card>
                <b-card v-else>
                    <b-alert show>
                        Select a SOP group
                    </b-alert>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="showNotifications">
            <b-col cols="12">
                <b-card>
                    <NotificationsTable
                    @selectedDocument="openDocumentFromNotification"
                    @selectedDocumentNotification="selectedDocument"
                    @viewDistributionRequest="showDistribution"
                    @back="clearSelectedNotification"
                    :group_notifications="selectedNotification"/>
                </b-card>
            </b-col>
        </b-row>
        <div @blur="hidePopper" tabindex="-1" @click="hidePopper" ref="contextPopper" id="poptest" v-show="showPopper">
            <ContextMenu :view_type="'client_admin'"  @action="actionHandler" @close="hidePopper"/>
        </div>
    </div>
</template>

<script>
//import Swal from "sweetalert2";
import { createPopper } from '@popperjs/core';
import ContextMenu from "@/components/widgets/contextDocuments";
import _ from 'lodash'
import NotificationsTable from '@/components/client_admin/sop/notificationsTable.vue'
import { sopClientAdminMethods, sopClientAdminState} from '@/state/helpers'
import SopCard from '@/components/widgets/misc/sopCard.vue'
export default {
    data:() => ({
        search_text: '',
        show_overlay: false,
        showPopper: false,
        popper_id: null,
        showNotifications: false,
        selectedNotification: null,
        selectedNotificationIndex: null,
    }),
    watch:{
        //TODO - USE THIS NEW UPDATED WAY OF LOADING SOPS (in the tree menu)
        /*selected_sop_group(newVal, oldVal){
            if(newVal !== oldVal && newVal != null){
                this.loadSops(this.selected_sop_group);
            }
        }*/
    },
    components:{
        NotificationsTable,
        ContextMenu,
        SopCard,
    },
    computed:{
        ...sopClientAdminState,
        returnGroupName(){
            let name = '';
            let index = _.findIndex(this.sop_groups, {id: this.selected_sop_group});
            if(index != -1){
                name = this.sop_groups[index].name;
            }
            return name;
        },
        documents(){
            if(this.selected_sop_group == null){
                return [];
            }
            else{
                if(this.search_text === ''){
                    let group = this.sop_groups.find( group => {
                        return group.id == this.selected_sop_group;
                    })
                    if(group){
                        return group.sops;
                    }
                    else{ return [];}
                }
                else{
                    let data = [];
                    let group = this.sop_groups.find( group => {
                        return group.id == this.selected_sop_group;
                    })
                    if(group){
                        data = _.cloneDeep(group.sops);
                    }
                    //let data = _.cloneDeep(this.sops.sop_types);
                    data = _.filter(data, function(o){
                        let valid = false;
                        let doc_name = o.name.toLowerCase();
                        let doc_code = o.sop_code.toLowerCase();
                        let text = window.inst.search_text.toLowerCase()
                        if(doc_name.includes(text) || doc_code.includes(text)){
                            valid = true;
                        }
                        return valid;
                    });
                    return data;
                }
                //return this.sops.sop_types;
            }
        },
        notification_count(){
            let count = 0;
            this.notification_data.forEach( notification_group => {
                count += notification_group.length;
            })
            return count;
        },
        notification_data(){
            let data = [];
            if(this.notifications != null){
                for (const key of Object.keys(this.notifications)) {
                    let item = {
                        name: _.replace(key, '_alerts', ''),
                        length: this.notifications[key].length,
                        icon: this.getIconType(key)
                    }
                    data.push(item);
                }
            }
            console.log(data);
            return data;
        },
        hasSopGroupSelected(){
            if(this.selected_sop_group == null){
                return false;
            }
            else{
                return true;
            }
        },
    },
    methods:{
        ...sopClientAdminMethods,
        selectedDocument(id){
            this.showNotifications = false;
            this.clearSopStore();
            this.show_overlay = true;
            this.loadSopData(id)
            .then(()=>{
                this.$emit('edit', id);
                this.show_overlay = false;
            })
            .catch((e)=>{
                console.log(e);
                this.show_overlay = false;
            })
        },
        clearSelectedNotification(){
            this.showNotifications = false;
            this.selectedNotification = null;
            this.selectedNotificationIndex = null;
        },
        viewDocumentFromNotification(payload){
            this.viewDocument(payload.id);
        },
        openDocumentFromNotification(payload){
            /*let index = _.findIndex(this.sop_groups, {id: payload.group_id});
            if(index != -1){
                this.selectSopGroup(payload.group_id)
                .then(()=>{
                    this.selectedDocument(payload.id);
                })
            }*/
            this.signPDF(payload.id)
        },
        showDistribution(sop_item){
            this.$emit('showDistribution', sop_item);

        },
        //* misc ----------
        getIconType(key){
            if(key === 'document_alerts'){
                return 'fa-file'
            }
            if(key === 'facility_alerts'){
                return 'fa-building'
            }
            if(key === 'training_alerts'){
                return 'fa-people-carry'
            }
            if(key === 'action_alerts'){
                return 'fa-bell'
            }
        },

        selectNotification(notification, index){
            console.log('Notification group ' + index);
            let key = notification.name + '_alerts'
            this.selectedNotification = this.notifications[key];
            this.selectedNotificationIndex = index;
            this.showNotifications = true;
        },


        //* popper.js stuff
        hidePopper(){
            if(this.debug != null){
                this.debug.destroy();
            }
            this.showPopper = false;
        },
        actionHandler(type){
            //* set document id for the component that is about to be displayed
            this.setContextMenuID(this.popper_id);
            //* handle action
            switch(type){
                case 'stats':{
                    this.$emit('showStats', this.popper_id)
                    break;
                }
                case 'distribute':{
                    this.$emit('showDirectDistribution', this.popper_id);
                    break;
                }
                case 'view':{
                    this.viewPDF(this.popper_id);
                    break;
                }
                case 'delete':{
                    this.show_overlay = true;
                    this.deleteSopType({id: this.popper_id})
                    .then(()=>{
                        this.loadSops(this.selected_sop_group)
                        .then(()=>{
                            this.show_overlay = false;
                        })
                    })
                    break;
                }
                case 'edit':{
                    let is_new = false;
                    this.showSopDialog(is_new);
                    break;
                }
                default:{
                    break;
                }
            }
        },
        viewDocument(id){
            this.loadSopData(id)
            .then(()=>{
                this.$emit('showNotificationDocument', id);
            })
        },
        signPDF(id){
            let options = {
                is_actionable_view: true,
                id: id,
            }
            this.loadSopData(id)
            .then(()=>{
                this.$emit('showPdfWrapper', options);
            });
        },
        viewPDF(id){
            let options = {
                is_actionable_view: false,
                id: id,
            }
            this.loadSopData(id)
            .then(()=>{
                this.$emit('showPdfWrapper', options);
            });
        },
        findSopById(sop_id){
            let item = this.documents.find( doc => { return doc.id == sop_id; });
            if(item){
                return item.name;
            }
            else{
                return '';
            }
        },
        async showSopDialog(is_new = true){
            let title_text = '';
            let alert_title = '';
            if(is_new){
                alert_title = "Create new document";
            }
            else{
                title_text = this.findSopById(this.popper_id);
                alert_title = `Edit document`
            }


            this.clearSopStore();

            //* Create Sweetalert input dialog
            const { value: name } = await this.$swal.fire({
                title: alert_title,
                input: 'textarea',
                inputValue: title_text,
                inputPlaceholder: 'Enter document title',
                showCancelButton: true,
            })
            if (name) {
                this.show_overlay = true;
                let params = {
                    id: is_new ? -1 : this.popper_id ,
                    client_group_id: this.selected_sop_group,
                    name: name,
                }
                //* Save sop, refresh sop group and add a default revision to the new sop
                this.saveSopType(params)
                .then((response)=>{
                    this.loadSops(this.selected_sop_group)
                    .then(()=>{
                        //* last saved id is used to set the document tile css
                        this.last_saved_sop_id = response.id;
                        if (is_new) {
                            this.insertFirstRevision(response.id);
                        }
                        this.show_overlay = false;
                    })
                })
            }
        },
        insertFirstRevision(id){
            let sop_type_id = id;

            let params = {
                sop_type_id: sop_type_id,
                sections:[
                    {
                        section_id: 'list_of_abbreviations',
                        section_order: 1,
                        body: '<p></p>',
                        section_title: 'Abbreviations',
                        content_height: '',
                    },
                    {
                        section_id: 'objective',
                        section_order: 2,
                        body: '<p></p>',
                        section_title: 'Objective',
                        content_height: '',
                    },
                    {
                        section_id: 'scope',
                        section_order: 3,
                        body: '<p></p>',
                        section_title: 'Scope',
                        content_height: '',
                    },
                    {
                        section_id: 'responsibility',
                        section_order: 4,
                        body: '<p></p>',
                        section_title: 'Responsibility',
                        content_height: '',
                    },
                    {
                        section_id: 'policy',
                        section_order: 5,
                        body: '<p></p>',
                        section_title: 'Policy',
                        content_height: '',
                    },
                    {
                        section_id: 'procedure',
                        section_order: 6,
                        body: '<p></p>',
                        section_title: 'Procedure',
                        content_height: '',
                    },
                    {
                        section_id: 'attachments_annexures',
                        section_order: 7,
                        body: '<p></p>',
                        section_title: 'Attachments',
                        content_height: '',
                    }
                ]
            }


            this.saveSopRevision(params)
            .then(()=>{
                this.$swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Saved!',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                    //timer: 2000, timerProgressBar: true
                });
            })
        },
        //eslint-disable-next-line
        clicker(event, id){
            //set id of right clicked document
            this.popper_id = id;
            this.hidePopper();
            this.$nextTick(()=>{
                this.showPopper = true;
                const doc = document.querySelector('#doc'+id)
                const popper = document.querySelector('#poptest')
                this.$nextTick(()=>{
                    this.debug = createPopper(doc, popper,{
                        placement: 'auto'
                    });
                    setTimeout(()=>{
                        if(this.$refs.contextPopper != undefined){
                            this.$refs.contextPopper.focus();
                        }
                    }, 250);
                })
            })
        },
    },
    mounted(){
        window.inst = this;
        this.$eventHub.$on('openDocument', this.selectedDocument);
        if(this.notifications == null){
            this.loadNotifications();
        }
    },
    beforeDestroy(){
        window.inst = undefined;
        this.$eventHub.$off('openDocument');
    }
}
</script>

<style>


</style>
